import { getOnecomConfig } from "../../selectors";

export const loadTldPrice = (tld) => {
  return (dispatch, getState, { api }) => {
    const state = getState();
    const { countryCode } = getOnecomConfig(state);

    return api.getTldPrice(tld, countryCode).then(
      (data) => {
        if (data.result) {
          return {
            wasSuccessful: true,
            tldPrice: { tld: tld, ...data.result },
          };
        } else {
          return { wasSuccessful: false };
        }
      },
      (err) => {
        return { wasSuccessful: false };
      },
    );
  };
};
